import $ from 'jquery';
import 'block-ui';

export default function() {
  $('#logon-btn, #logon-btn-mobile').click(function (e) {
      var form = this.form;
      e.preventDefault();
      $.blockUI({
          message: '<div class="loading-spinner-60 spinner-padding"></div><div class="spinner-font" role="alert" aria-live="assertive">Please wait...</div>',
          css: { borderRadius: '3px', borderColor: '#fff', height: '168px', width: '168px' }
       });
      setTimeout(function() {
          form.submit();
      }, 1000);
  });
}



// WEBPACK FOOTER //
// ./src/webpack/components/logon-spinner.js